// For Firebase JS SDK v7.20.0 and later, measurementId is optional
import firebase from "firebase";

const firebaseConfig = {
  apiKey: "AIzaSyC0PCV4YGSuNdsjhCag2xLb4HwiclvFtsU",
  authDomain: "clone-27630.firebaseapp.com",
  projectId: "clone-27630",
  storageBucket: "clone-27630.appspot.com",
  messagingSenderId: "582594125803",
  appId: "1:582594125803:web:51f8673d2db49ffcb143ae",
  measurementId: "G-WQLPY6VDDX"
};

const firebaseApp = firebase.initializeApp(firebaseConfig);
const db = firebaseApp.firestore();
const auth = firebase.auth();

export { db, auth };